import React from "react";
import { PhosphorBellButton, PhosphorEnvelopeSimpleButton, PhosphorIconButtonProps } from "./PhosphorIconButton";
import { AxiosPromise } from "axios";

interface ToggleablePhosphorIconButtonProps extends Omit<PhosphorIconButtonProps, "onClick" | "iconWeight"> {
  initialValue: boolean
  update: (value: boolean) => AxiosPromise<server.dto.ApiResponseWrapper<boolean>>
}

export const ToggleableBellPhosphorIconButton = (props: ToggleablePhosphorIconButtonProps) => {
  const { initialValue, update, ...rest } = props;
  const [value, setValue] = React.useState(initialValue);

  const onClick = async () => {
    const response = await update(!value);
    if (response.status !== 200 || response.data.hasErrors) {
      return;
    }
    setValue(!value);
  };

  return <PhosphorBellButton
    {...rest}
    iconColor={value ? null : "gray"}
    selectedStyle={value ? "blue-line" : null}
    onClick={onClick}
  />
}

export const ToggleableEmailPhosphorIconButton = (props: ToggleablePhosphorIconButtonProps) => {
  const { initialValue, update, ...rest } = props;
  const [value, setValue] = React.useState(initialValue);

  const onClick = async () => {
    const response = await update(!value);
    if (response.status !== 200 || response.data.hasErrors) {
      return;
    }
    setValue(!value);
  };

  return <PhosphorEnvelopeSimpleButton
    {...rest}
    iconColor={value ? null : "gray"}
    selectedStyle={value ? "blue-line" : null}
    onClick={onClick}
  />
}